module.exports = __webpack_public_path__ + "static/media/flow-02.17f53094.png";